import { formatMoneyValue } from '@utils/moneyFormatting';
import { Typography } from 'hephaestus/web';
import { round } from 'lodash-es';

const formatFraction = (fraction: number | undefined) =>
  !isFinite(fraction || 0)
    ? '100.00'
    : round((fraction || 0) * 100, 2).toFixed(2);

const getDeviationColor = ({
  showColor,
  isRedColor,
  percentage,
}: {
  showColor: boolean;
  isRedColor: boolean;
  percentage?: number;
}) => {
  if (!showColor) return undefined;
  if (isRedColor) return 'error';

  const magnitude = Math.abs(percentage ?? 0);
  if (magnitude > 0.1) return 'error';
  if (magnitude > 0.05) return 'warning';

  return undefined;
};

const SmallDollarPercentage = ({
  cents,
  percentage,
  secondaryPercentage,
  bold = false,
  showColor = false,
  showPercentage = true,
  isRedColor = false,
  className,
}: {
  cents: number;
  percentage?: number;
  /** Portfolio-wide target % (0–1), inline beside within-class % when shown. */
  secondaryPercentage?: number;
  bold?: boolean;
  showColor?: boolean;
  showPercentage?: boolean;
  isRedColor?: boolean;
  className?: string;
}) => {
  const value = formatMoneyValue(round(cents) || 0);
  return (
    <Typography
      variant='labelSmall'
      sx={{ fontWeight: bold ? 800 : 400, fontVariantNumeric: 'tabular-nums' }}
      className={className}
      color={getDeviationColor({ showColor, isRedColor, percentage })}
    >
      {value}
      {showPercentage && (
        <>
          <br />
          {formatFraction(percentage)}%
          {secondaryPercentage != null && (
            <>
              {' · '}
              <Typography
                component='span'
                variant='labelSmall'
                color={bold ? 'inherit' : 'text.secondary'}
                sx={{
                  fontSize: 'inherit',
                  fontVariantNumeric: 'tabular-nums',
                  fontWeight: bold ? 800 : 400,
                }}
              >
                {formatFraction(secondaryPercentage)}%
              </Typography>
            </>
          )}
        </>
      )}
    </Typography>
  );
};

export default SmallDollarPercentage;
